var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8001\\u8BB8-\\u5B9E\\u65F6\\u76D1\\u63A7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1007461-\\u5B9E\\u65F6\\u76D1\\u63A7-\\u8BA1\\u91CF\\u7535\\u8868",
    transform: "translate(-26.000000, -1191.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-city",
    transform: "translate(26.500000, 1191.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "city-outline",
    transform: "translate(3.025201, 2.076172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07856178,0 L0.736795367,0 C0.330406672,0 0,0.381868716 0,0.851553931 L0,11.0702011 C0,11.5398863 0.330406672,11.921755 0.736795367,11.921755 L6.07856178,11.921755 C6.48495047,11.921755 6.81535714,11.5398863 6.81535714,11.0702011 L6.81535714,0.851553931 C6.81535714,0.381868716 6.48495047,0 6.07856178,0 Z M9.75816504,4.29183181 L6.38785267,4.29183181 C6.13144744,4.29183181 5.922982,4.53622779 5.922982,4.83682633 L5.922982,11.3767605 C5.922982,11.6773591 6.13144744,11.921755 6.38785267,11.921755 L9.75816504,11.921755 C10.0145703,11.921755 10.2230357,11.6773591 10.2230357,11.3767605 L10.2230357,4.83682633 C10.2230357,4.53622779 10.0145703,4.29183181 9.75816504,4.29183181 Z M5.79386687,10.9448463 L0.998343331,10.9448463 L0.998343331,0.927350028 L5.79386687,0.927350028 L5.79386687,10.9448463 Z M9.41957516,11.1483656 L6.55287268,11.1483656 L6.55287268,5.19725072 L9.41957516,5.19725072 L9.41957516,11.1483656 Z M2.27178571,2.20079241 L4.54357143,2.20079241 L4.54357143,3.33668527 L2.27178571,3.33668527 Z M2.27178571,5.33668527 L4.54357143,5.33668527 L4.54357143,6.47257812 L2.27178571,6.47257812 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.65,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-6",
    fill: "#59D744",
    x: 2.27178571,
    y: 8.47257812,
    width: 2.27178571,
    height: 1.13589286
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-7",
    fill: "#59D744",
    x: 7.56758189,
    y: 7.85433068,
    width: 1.09807806,
    height: 3.29145082
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.0519a0e6a0d99f85cecf4b8602ec981f.svg";
export { ForwardRef as ReactComponent };